import React from "react";
import AgentCard from "./AgentCard";

const AgentMonitoringSection = ({
  agents,
  onAgentClick,
  onWidgetClick,
  onTestWhatsApp,
  onToggleEnabled,
  togglingAgentId,
}) => {
  return (
    <div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {agents.map((agent) => (
          <AgentCard
            key={agent.id}
            agent={agent}
            onClick={() => onAgentClick(agent)}
            onWidgetClick={onWidgetClick}
            onTestWhatsApp={onTestWhatsApp}
            onToggleEnabled={onToggleEnabled}
            isTogglePending={togglingAgentId === agent.id}
          />
        ))}
      </div>
    </div>
  );
};

export default AgentMonitoringSection;
